import { Module } from 'vuex'
import { RootState } from '@/store'
import mutations from '@/store/legacy/mutations'
import { path } from '@/store/legacy/types'
import { mutation } from '@/utils/mutation'
import state, { ILegacyState } from '@/store/legacy/state'

export * from '@/store/legacy/state'

export const store: Module<ILegacyState, RootState> = {
  state,
  mutations: mutation(mutations, path)
}
